export default __webpack_public_path__ + "static/media/bg_pop.08356100.png";